import React from "react";

export const ValueComparisonChart = () => (
    <svg width="686" height="209" viewBox="0 0 686 209" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="31" y="0.75" width="132" height="208" rx="4" fill="#F9F9FF" />
        <rect x="31" y="89.75" width="132" height="119" rx="4" fill="#333333" />
        <rect x="243" y="0.75" width="132" height="208" rx="4" fill="#F9F9FF" />
        <rect
            x="243"
            y="0.75"
            width="132"
            height="90"
            rx="4"
            fill="#DBDAFF"
            stroke="#624AC5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="4 4"
        />
        <rect x="454" y="0.75" width="132" height="208" rx="4" fill="#F9F9FF" />
        <rect x="455" y="0.75" width="132" height="208" rx="4" fill="#5BCD75" />
        <line x1="4.37114e-08" y1="208.25" x2="686" y2="208.25" stroke="#DAD9D9" />
        <path d="M162 90.75H243" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="4 4" />
        <path
            d="M375 1.75L455 1.75001"
            stroke="#767676"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeDasharray="4 4"
        />
    </svg>
);
